import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import InvestmentsForm from './InvestmentsForm';
import { setAccountData } from 'store/features/account/actions';
import { AppDispatch, RootState } from 'store/types';

const mapStateToProps = (state: RootState) => {
  return {
    account: state.account,
    isConnected: state.roles.isConnected,
    project: state.investments?.id || 0,
    name: state.investments.name,
    domain: state.investments.domain,
  }
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ setAccountData }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentsForm);
